import memoize from 'memoize-one';
import { useSelector } from 'react-redux';

export default function useSiteModalOpen() {
  const siteModalOpen = useSelector(state => appStateModalOpenSelector(state.appState));
  const tourRunning = useSelector(state => state.siteTours.status.running);

  return !!(siteModalOpen || tourRunning);
}

const appStateModalOpenSelector = memoize(
  appState =>
    appState.show_reauthentication_form ||
    appState.toggle_contact_us_form ||
    (appState.toggle_login_form && !appState.toggle_login_form.hidden) ||
    appState.toggle_privacy_policy ||
    appState.toggle_search ||
    appState.toggle_terms_and_conditions,
);
